import React, { useState, useEffect } from "react";
import { allUsersApi } from "../../api/api";
import LoadingSpiner from "../Common/LoadingSpiner";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./DataVisualizationPage.css";

// Assuming `CustomShape` and `CustomTooltip` remain unchanged
const CustomShape = (props) => {
  const { cx, cy, riskScore } = props;
  const fillColor = riskScore >= 7 ? "#d84a4a" : "#8884d8";
  return <circle cx={cx} cy={cy} r={4} fill={fillColor} />;
};

const BAC_WEIGHT = 0.4;
const BRAC_WEIGHT = 0.3;
const DRINKS_WEIGHT = 0.3;

let acuteRiskScore = 0;

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#ffff",
          padding: "5px",
          border: "1px solid #cccc",
        }}
      >
        <p>{`Name: ${data.name}`}</p>
        <p>{`Risk Score: ${data.riskScore}`}</p>
      </div>
    );
  }

  return null;
};
const DataVisualizationPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    const res = await allUsersApi();

    if (res) {
      const newData = res.map((data, index) => ({
        ...data.user,
        index: index, // Assign a numerical index for plotting
        uniqueIdentifier: data.user.name, // Assuming `name` is unique; adjust as needed
        riskScore: data.user.auditC,
      }));

      setData(newData);
      setLoading(false);
    }
  };

  const testData = {
    labels: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    datasets: [
      {
        label: "Audit-C",
        data: [4, 5, 6, 8, 9, 6, 4],
        borderColor: "#8c6bb1",
        backgroundColor: "#8c6bb1",
        fill: false,
        lineTension: 0.2,
      },
      {
        label: "BAC (%)",
        data: [0.1, 0.2, 0.25, 0.35, 0.3, 0.2, 0.1],
        borderColor: "#fdd835",
        backgroundColor: "#fdd835",
        fill: false,
        lineTension: 0.2,
        yAxisID: "y1",
      },
    ],
  };

  if (loading) {
    return <LoadingSpiner loading={loading} />;
  } else {
    return (
      <div className="dataVisualizationPage">
        <div>
          <h1 className="dataVisualizationTitle">
            What would you like to analyze today?
          </h1>
        </div>
        <div className="patient-dashboard">
          <div className="chart-buttons">
            <button className="chart-button">Audit-C</button>
            <button className="chart-button">BAC (%)</button>
          </div>
          <ResponsiveContainer width="100%" height={400}>
            <ScatterChart
              margin={{
                top: 100,
                right: 20,
                bottom: 20,
                left: 20,
              }}
            >
              <CartesianGrid />
              <XAxis
                type="category"
                dataKey="uniqueIdentifier"
                name="User"
                interval={0}
                tick={{ angle: -45, textAnchor: "end" }}
                height={100}
              />
              <YAxis type="number" dataKey="riskScore" name="Risk Score" />
              <Tooltip
                cursor={{ strokeDasharray: "3 3" }}
                content={<CustomTooltip />}
              />
              <Legend />
              <Scatter
                name="Patients"
                data={data}
                fill="#8884d8"
                shape={<CustomShape />}
              />
            </ScatterChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
};

export default DataVisualizationPage;
